import { formHelperTextClasses } from "@mui/material";
import type { Components, Theme } from "@mui/material/styles";

export const MuiFormHelperText: Components<Theme>["MuiFormHelperText"] = {
  styleOverrides: {
    root: {
      [`&.${formHelperTextClasses.error}`]: {
        color: `light-dark(var(--mui-palette-error-main), var(--mui-palette-error-lightest))`,
      },
    },
  },
};
